import update from './update'

const remove = (objects, path) => {
  return update(objects, path)
}

export default remove
